var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarningIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 256,
  height: 256,
  viewBox: "0 0 256 256",
  xmlSpace: "preserve",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
  style: {
    stroke: "none",
    strokeWidth: 0,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "nonzero",
    opacity: 1
  },
  transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 45 88.11 h 40.852 c 3.114 0 5.114 -3.307 3.669 -6.065 L 48.669 4.109 c -1.551 -2.959 -5.786 -2.959 -7.337 0 L 0.479 82.046 c -1.446 2.758 0.555 6.065 3.669 6.065 H 45 z",
  style: {
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    fill: "rgb(255,157,0)",
    fillRule: "nonzero",
    opacity: 1
  },
  transform: " matrix(1 0 0 1 0 0) ",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 45 64.091 L 45 64.091 c -1.554 0 -2.832 -1.223 -2.9 -2.776 l -2.677 -25.83 c -0.243 -3.245 2.323 -6.011 5.577 -6.011 h 0 c 3.254 0 5.821 2.767 5.577 6.011 L 47.9 61.315 C 47.832 62.867 46.554 64.091 45 64.091 z",
  style: {
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    fill: "rgb(255,255,255)",
    fillRule: "nonzero",
    opacity: 1
  },
  transform: " matrix(1 0 0 1 0 0) ",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44.995999999999995,
  cy: 74.02600000000001,
  r: 4.626,
  style: {
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    fill: "rgb(255,255,255)",
    fillRule: "nonzero",
    opacity: 1
  },
  transform: "  matrix(1 0 0 1 0 0) "
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarningIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/warning-icon.86aef529c158bb8097f43cb5c6f0443c.svg";